{
"catalog": {
" company has been added": " f\u00f6retag har lagts till",
" day. Renew now to continue enjoying uninterrupted access.": " dag. F\u00f6rnya nu f\u00f6r att forts\u00e4tta njuta av oavbruten \u00e5tkomst.",
" days. Renew now to continue enjoying uninterrupted access.": " dagar. F\u00f6rnya nu f\u00f6r att forts\u00e4tta njuta av oavbruten \u00e5tkomst.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0,00",
": The new company has been added": ": Det nya f\u00f6retaget har lagts till",
"A code of reference ( Who referred a company)": "En referenskod (Vem h\u00e4nvisade till ett f\u00f6retag)",
"A link has been sent to your email address to reset password": "En l\u00e4nk har skickats till din e-postadress f\u00f6r att \u00e5terst\u00e4lla l\u00f6senordet",
"A link has been sent to your email address to reset password.": "En l\u00e4nk har skickats till din e-postadress f\u00f6r att \u00e5terst\u00e4lla l\u00f6senordet.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "En nyare version av denna applikation finns tillg\u00e4nglig. Uppdateringen p\u00e5b\u00f6rjas automatiskt om 20 sekunder.",
"A suspicious activity was detected. For security reasons, you must log in again": "En misst\u00e4nkt aktivitet har uppt\u00e4ckts. Av s\u00e4kerhetssk\u00e4l m\u00e5ste du logga in igen",
"API Documentation": "API-dokumentation",
"API Key": "API-nyckel",
"API key": "API-nyckel",
"Access from partner website": "\u00c5tkomst fr\u00e5n partnerwebbplats",
"Access given": "Tillg\u00e5ng ges",
"Access is Required!": "Tilltr\u00e4de kr\u00e4vs!",
"Access period": "Tilltr\u00e4desperiod",
"Account Setup": "Inst\u00e4llning av konto",
"Account creation code": "Kod f\u00f6r skapande av konto",
"Actions": "\u00c5tg\u00e4rder",
"Active": "Aktiv",
"Active Users": "Aktiva anv\u00e4ndare",
"Active Users List": "Lista \u00f6ver aktiva anv\u00e4ndare",
"Add": "L\u00e4gg till",
"Add Contract": "L\u00e4gg till kontrakt",
"Add Corporate Group": "L\u00e4gg till f\u00f6retagsgrupp",
"Add Customer": "L\u00e4gg till kund",
"Add Document": "L\u00e4gg till dokument",
"Add Historical Data Limit": "L\u00e4gg till historisk datagr\u00e4ns",
"Add New Corporate Group": "L\u00e4gg till ny f\u00f6retagsgrupp",
"Add New Feature": "L\u00e4gg till ny funktion",
"Add New Module": "L\u00e4gg till ny modul",
"Add New Partner": "L\u00e4gg till partner",
"Add New Subscription": "L\u00e4gg till ny prenumeration",
"Add New User": "L\u00e4gg till ny anv\u00e4ndare",
"Add Partner": "L\u00e4gg till partner",
"Add User": "L\u00e4gg till anv\u00e4ndare",
"Add a new role": "L\u00e4gg till en ny roll",
"Add company": "L\u00e4gg till f\u00f6retag",
"Add contract": "L\u00e4gg till kontrakt",
"Add feature": "L\u00e4gg till funktion",
"Add permission": "L\u00e4gg till beh\u00f6righet",
"Add role": "L\u00e4gg till roll",
"Add subscription plan": "L\u00e4gg till prenumerationsplan",
"Address": "Adress",
"Aggregated": "Aggregerad",
"Aggregation": "Aggregering",
"Alias": "Alias",
"All": "Alla",
"All Documents": "Alla dokument",
"All Partners": "Alla partners",
"All Users": "Alla Anv\u00e4ndare",
"All kWh": "Alla kWh",
"All notifications deleted successfully": "Alla meddelanden har raderats",
"All notifications marked as read": "Alla aviseringar har markerats som l\u00e4sta",
"Alpha numeric and dash only": "Endast alfanumeriska siffror och bindestreck",
"Already have an account?": "Har du redan ett konto?",
"Amount of money for consumption": "Penningbelopp f\u00f6r konsumtion",
"An error occurred while deleting the document": "Ett fel uppstod n\u00e4r dokumentet raderades.",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Ett fel intr\u00e4ffade n\u00e4r systemet genererade rapporten. V\u00e4nligen f\u00f6rs\u00f6k igen. Du kan kontakta support om detta forts\u00e4tter.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Ett ov\u00e4ntat fel har intr\u00e4ffat. Det har loggats och vi arbetar p\u00e5 en l\u00f6sning.",
"Annual CO\u2082e (Kg)": "\u00c5rlig CO\u2082e (kg)",
"Annual Statement": "\u00c5rligt uttalande",
"Annual energy consumption (kWh)": "\u00c5rlig energif\u00f6rbrukning (kWh)",
"App": "App",
"App URL": "Appens URL",
"Apr": "Apr",
"Apr: Checking": "Apr: Kontroll",
"Apr: Get": "Apr: H\u00e4mta",
"Apr: Update": "Apr: Uppdatering",
"April": "April",
"Are you sure you want to delete this notification ? ": "\u00c4r du s\u00e4ker p\u00e5 att du vill ta bort denna avisering? ",
"Are you sure you want to delete?": "\u00c4r du s\u00e4ker?",
"Attach Company with User": "Bifoga f\u00f6retag med anv\u00e4ndare",
"Aug": "Aug",
"Aug: Checking": "Aug: Kontroll",
"Aug: Get": "Aug: H\u00e4mta",
"Aug: Update": "Aug: Uppdatering",
"August": "Augusti",
"Authority Processing": "Myndighetsbehandling",
"Authorization": "Auktorisering",
"Availability Payment": "Tillg\u00e4nglighet Betalning",
"Availability Rate": "Tillg\u00e4nglighetspris",
"Back": "Tillbaka",
"Back to": "Tillbaka till",
"Back to Documents": "Tillbaka till dokument",
"Basic Information": "Grundinformation",
"Before getting started, could you verify your email address by ": "Innan du b\u00f6rjar, kan du verifiera din e-postadress genom att  ",
"Blocked": "Blockerad",
"Building": "Byggnad",
"Building address": "Byggnadens adress",
"Building is required": "Byggnad kr\u00e4vs",
"But you still need to know more.": "Men du beh\u00f6ver fortfarande veta mer.",
"CAPTCHA verification failed. Please try again.": "CAPTCHA-verifieringen misslyckades. F\u00f6rs\u00f6k igen.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "CCPA:s integritetsr\u00e4ttigheter (s\u00e4lj inte min personliga information)",
"CO\u2082_per_m2": "CO\u2082_per_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (kg)",
"CVR": "F\u00f6retagets nummer",
"Cached": "Cachad",
"Cancel": "Avbryt",
"Carbon Emissions (Kg CO\u2082e)": "Koldioxidutsl\u00e4pp (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Koldioxidavtryck (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Koldioxid F\u00f6rbrukning",
"Cashed Statement - Under Development": "Cashed Statement - under utveckling",
"Central business Register number": "Centralt f\u00f6retagsregisternummer",
"Change Password": "\u00c4ndra l\u00f6senord",
"Change password": "\u00c4ndra l\u00f6senord",
"Checking Cache": "Kontrollera cacheminnet",
"Child Company": "Barnf\u00f6retag",
"Child company and above level access": "Underf\u00f6retag och \u00e5tkomst p\u00e5 h\u00f6gre niv\u00e5",
"City": "Stad",
"Clear above cache": "Rensa cacheminnet",
"Clear all cache": "Rensa all cache",
"Clear browser memory / Page reload": "Rensa webbl\u00e4sarens minne / Ladda om sidan",
"Click to copy": "Klicka f\u00f6r att kopiera",
"Click to upload or drag and drop": "Klicka f\u00f6r att ladda upp eller dra och sl\u00e4pp",
"Climate": "Klimat",
"Climate report": "Klimatrapport",
"Close": "St\u00e4ng",
"Co2 Certificates": "Koldioxidcertifikat",
"Code": "Kod",
"Coming Soon": "Kommer snart",
"Commission Price": "Provision",
"Commission Share": "Provisionsandel",
"Companies": "F\u00f6retag",
"Companies for ": "F\u00f6retag f\u00f6r ",
"Companies for the corporate group: ": "F\u00f6retag i koncernen: ",
"Company": "F\u00f6retag",
"Company Authenticity number": "F\u00f6retagets \u00e4kthetsnummer",
"Company Name": "F\u00f6retagsnamn",
"Company No.": "F\u00f6retag nr.",
"Company Number": "F\u00f6retagets nummer",
"Company Roles": "F\u00f6retagets roller",
"Company Users for ": "F\u00f6retagsanv\u00e4ndare f\u00f6r ",
"Company name": "F\u00f6retagsnamn",
"Company website": "F\u00f6retagets hemsida",
"Compensation": "Kompensation",
"Confirm Email Address": "Bekr\u00e4fta e-postadressen",
"Confirm Password": "Bekr\u00e4fta l\u00f6senord",
"Confirm Password is required": "Bekr\u00e4fta l\u00f6senord kr\u00e4vs",
"Confirm password does not match.": "L\u00f6senordet matchar inte.",
"Confirmation": "Bekr\u00e4ftelse",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Grattis, du har valt den b\u00e4sta plattformen f\u00f6r energif\u00f6rbrukning",
"Consent": "Samtycke",
"Consumption": "Standard f\u00f6rbrukningskvantitet f\u00f6r batch",
"Consumption (kWh)": "F\u00f6rbrukning (kWh)",
"Consumption and CO\u2082e": "F\u00f6rbrukning och CO\u2082e",
"Consumption is kWh": "F\u00f6rbrukningen \u00e4r kWh",
"Consumption measured in kWh": "F\u00f6rbrukning m\u00e4tt i kWh",
"Contact Name": "Kontaktpersonens namn",
"Contact Phone": "Telefonnummer",
"Continue": "Forts\u00e4tt",
"Contract list": "Avtalslista",
"Contracts": "Avtal",
"Conversion Rate": "Konverteringsfaktor",
"Conversion Rate for CO\u2082e": "Omvandlingsfaktor f\u00f6r CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "Omvandlingsfaktor i g CO\u2082e/kWh",
"Copied to clipboard": "Kopierat till urklipp",
"Corporate Group": "F\u00f6retagsgrupp",
"Corporate Groups": "F\u00f6retagsgrupper",
"Corporate Groups for the partner ": "F\u00f6retagsgrupper f\u00f6r partnern ",
"Corporate group and above level access": "F\u00f6retagsgrupp och \u00e5tkomst p\u00e5 h\u00f6gre niv\u00e5",
"Cost": "Kostnad",
"Cost (DKK)": "Kostnad (DKK)",
"Cost in DKK": "Anskaffningsv\u00e4rde i DKK",
"Country": "Land",
"Country code": "Landskod",
"Country, Timezone and Corporate Group is Required!": "Land, tidszon och f\u00f6retagsgrupp \u00e4r obligatoriska uppgifter!",
"Create Historical Data Limit": "Skapa historiska datagr\u00e4nser",
"Create New Contract": "Skapa nytt avtal",
"Create a new password": "Skapa ett nytt l\u00f6senord",
"Create or get an API key to access your data.": "Skapa eller h\u00e4mta en API-nyckel f\u00f6r att f\u00e5 tillg\u00e5ng till dina data.",
"Created At": "Skapad den",
"Created By": "Skapad av",
"Currency": "Valuta",
"Currency is required": "Valuta kr\u00e4vs",
"Current Password": "Nuvarande l\u00f6senord",
"Current month only": "Endast innevarande m\u00e5nad",
"Current year only": "Endast innevarande \u00e5r",
"Customer": "Kund",
"DKK": "DKK",
"Daily": "Dagligen",
"Danish": "Danska",
"Data Delivered By": "Data levererad av",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Data granularitet. PT1H = var 1:e timme, PT15M = var 15:e minut",
"Data is currently being loaded. Please hold on a moment.": "Data h\u00e5ller f\u00f6r n\u00e4rvarande p\u00e5 att laddas. V\u00e4nligen v\u00e4nta ett \u00f6gonblick.",
"Data validation - consumption": "Validering av data - f\u00f6rbrukning",
"DataHub": "DataHub",
"Date": "Datum",
"Date when the access is given": "Datum d\u00e5 tillg\u00e5ngen ges",
"Day": "Dag",
"Day Report - Under development": "Dagrapport \u2013 Under utveckling",
"Days": "Dagar",
"Dear {{user_full_name}}": "K\u00e4ra {{user_full_name}}",
"Dec": "Dec",
"Dec: Checking": "Dec: Kontroll",
"Dec: Get": "Dec: H\u00e4mta",
"Dec: Update": "Dec: Uppdatering",
"December": "December",
"Delete": "Radera",
"Delete API Key": "Radera API-nyckel",
"Delete All Notifications": "Ta bort alla aviseringar",
"Deleted": "Raderad",
"Description": "Beskrivning",
"Developer": "Utvecklare",
"Did you forget your password? Create a new one by clicking the button below.": "Har du gl\u00f6mt ditt l\u00f6senord? Skapa ett nytt genom att klicka p\u00e5 knappen nedan.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Har du f\u00e5tt det h\u00e4r e-postmeddelandet av misstag? I s\u00e5 fall \u00e4r det ingen fara - du kan bara ignorera det.",
"Difference": "Skillnad",
"Discount Net Tariff": "Rabatt Netto Tariff",
"Discount Subscription": "Rabatterad prenumeration",
"Distribution": "Distribution",
"District Heating": "Fj\u00e4rrv\u00e4rme",
"Do you know?": "Vet du vad?",
"Do you want to delete the document?": "Vill du ta bort dokumentet?",
"Do you want to delete the historical data limit?": "Vill du ta bort gr\u00e4nsen f\u00f6r historiska data?",
"Do you want to delete the notification?": "Vill du ta bort meddelandet?",
"Do you want to unlink the company?": "Vill du ta bort kopplingen till bolaget?",
"Do you want to unlink the user?": "Vill du ta bort kopplingen till anv\u00e4ndaren?",
"Document Details": "Dokumentdetaljer",
"Document For": "Dokument f\u00f6r",
"Document Preview": "Dokumentf\u00f6rhandsgranskning",
"Document Type": "Dokumenttyp",
"Document Uploading Failed": "Dokumentuppladdning misslyckades",
"Document deleted successfully": "Dokumentet har raderats",
"Document list": "Dokumentlista",
"Document not found": "Dokumentet hittades inte",
"Document updated successfully": "Dokumentet har uppdaterats",
"Document uploaded successfully": "Dokumentet har laddats upp",
"Documents": "Dokument",
"Don't Have An Account Yet?": "Har du inte ett konto \u00e4n?",
"Download": "Ladda ner",
"Download Climate Report": "Ladda ner klimatrapport",
"Download Cost Report": "Ladda ner kostnadsrapport",
"Download Document": "Ladda ner dokument",
"Download Energy Report": "Ladda ner energirapport",
"Download For App": "Ladda ner f\u00f6r app",
"Download For WWW": "Ladda ner f\u00f6r WWW",
"Download Sport Price Report": "Ladda ner Sport Prisrapport",
"Download report": "Ladda ned rapport",
"Drag and drop files here or click": "Dra och sl\u00e4pp filer h\u00e4r eller klicka",
"Drop the file here or": "L\u00e4mna filen h\u00e4r eller",
"Dutch": "Nederl\u00e4ndska",
"EPAD": "EPAD",
"EPAD Price": "EPAD Pris",
"EPAD Share": "EPAD-aktien",
"EPAD Type": "EPAD-typ",
"EPAD kWh": "EPAD kWh",
"Edit": "Redigera",
"Edit Contract": "Redigera avtalet",
"Edit Corporate Group": "Redigera f\u00f6retagsgrupp",
"Edit Document Details": "Redigera dokumentdetaljer",
"Edit Feature": "Redigera funktionen",
"Edit Historical Data Limit": "Redigera gr\u00e4ns f\u00f6r historiska data",
"Edit Module": "Redigera modul",
"Edit Partner": "Redigera partner",
"Edit Role": "Redigera roll",
"Edit Subscription": "Redigera Prenumeration",
"Edit User": "Redigera anv\u00e4ndare",
"Edit User Company": "Redigera anv\u00e4ndare F\u00f6retag",
"Effect Payment": "Effekt Betalning",
"Effortless energy insights at your fingertips": "Enkla energiinsikter till hands p\u00e5 ett smidigt s\u00e4tt",
"Ekskl. moms": "Exkl. moms",
"Electricity": "Elektricitet",
"Electricity Charge": "Elavgift",
"Electricity consumption": "Elf\u00f6rbrukning",
"Electricity measured in kWh": "El m\u00e4tt i kWh",
"Email": "E-post",
"Email Not Verified": "E-postadress ej verifierad",
"Email Sent ": "E-post skickad ",
"Email address": "E-postadress",
"Email is required.": "E-post kr\u00e4vs.",
"End": "Slut",
"End Date": "Slutdatum",
"Energy": "Energi",
"Energy Consumption (kWh)": "Energif\u00f6rbrukning (kWh)",
"Energy Contract": "Energikontrakt",
"Energy Type": "Typ av energi",
"Energy report": "Energirapport",
"Energy type is required": "Energityp kr\u00e4vs",
"English": "Engelska",
"Enter description": "Kursbeskrivning",
"Enter email": "Skriv in postadressen",
"Enter email address": "Ange en e-postadress",
"Enter email address to continue.": "Ange e-postadress f\u00f6r att forts\u00e4tta.",
"Enter full name": "Ange fullst\u00e4ndigt namn",
"Enter name": "Ange namn",
"Enter password": "Ange l\u00f6senord",
"Enter password again": "Ange l\u00f6senordet igen",
"Enter your new password to reset": "Ange ditt nya l\u00f6senord f\u00f6r att \u00e5terst\u00e4lla",
"Error loading image:": "Fel vid laddning av bild:",
"Error: Something went wrong!": "Fel: N\u00e5got gick fel!",
"Error: Something went wrong! ": "Fel: N\u00e5got gick fel! ",
"Excel Reports": "Excel-rapporter",
"Excel Update": "Excel-uppdatering",
"Expire At": "Utg\u00e5r vid",
"Export": "Exportera",
"Export to Excel": "Exportera till Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Fabeke Data",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke f\u00f6ljer ett standardf\u00f6rfarande f\u00f6r anv\u00e4ndning av loggfiler. Dessa filer loggar bes\u00f6kare n\u00e4r de bes\u00f6ker webbplatser. Alla hostingf\u00f6retag g\u00f6r detta och det \u00e4r en del av hostingtj\u00e4nsternas analys. Den information som samlas in av loggfiler inkluderar IP-adresser (Internet Protocol), webbl\u00e4sartyp, Internet Service Provider (ISP), datum- och tidsst\u00e4mpel, h\u00e4nvisnings-/utg\u00e5ngssidor och eventuellt antalet klick. Dessa \u00e4r inte kopplade till n\u00e5gon information som \u00e4r personligt identifierbar. Syftet med informationen \u00e4r att analysera trender, administrera webbplatsen, sp\u00e5ra anv\u00e4ndarnas r\u00f6relser p\u00e5 webbplatsen och samla in demografisk information.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "Fabekes integritetspolicy g\u00e4ller inte f\u00f6r andra annons\u00f6rer eller webbplatser. D\u00e4rf\u00f6r rekommenderar vi dig att l\u00e4sa respektive integritetspolicy f\u00f6r dessa tredjepartsannonsservrar f\u00f6r mer detaljerad information. Det kan inkludera deras praxis och instruktioner om hur man v\u00e4ljer bort vissa alternativ.",
"Failed to delete document": "Det gick inte att ta bort dokumentet",
"Failed to load document preview. Please try downloading the document.": "Det gick inte att ladda dokumentf\u00f6rhandsvisningen. F\u00f6rs\u00f6k ladda ner dokumentet.",
"Failed to unlink. ": "Misslyckades med att koppla bort l\u00e4nken. ",
"Feature": "Funktion",
"Feature Name": "Utvalt namn",
"Feature key, Alpha numeric and dash only": "Funktionstangent, endast alfanumerisk och bindestreck",
"Features": "Funktioner",
"Features for ": "Funktioner f\u00f6r ",
"Feb": "Feb",
"Feb: Checking": "Februari: Kontroll",
"Feb: Get": "Februari: H\u00e4mta",
"Feb: Update": "Feb: Uppdatering",
"February": "Februari",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "H\u00f6r g\u00e4rna av dig till kundtj\u00e4nst. De finns p\u00e5 plats dygnet runt f\u00f6r att hj\u00e4lpa dig.",
"File Name": "Filnamn",
"File type not supported": "Filtypen st\u00f6ds inte",
"Fixed": "Fast",
"Fixed Price": "Fast pris",
"Fixed price": "Fast pris",
"Fixed price ex epad": "Fast pris ex epad",
"Fixed price ex epad and profile": "Fast pris ex epad och profil",
"Fixed price ex profile": "Fast pris ex profil",
"Fixed profile ex spot": "Fast profil ex spot",
"For further information, please read CO2 emissions from Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ": "F\u00f6r ytterligare information, se CO2-utsl\u00e4pp fr\u00e5n Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ",
"Forgot Password": "Gl\u00f6mt l\u00f6senord",
"Forgot Your Password?": "Har du gl\u00f6mt ditt l\u00f6senord?",
"Forgot your password?": "Gl\u00f6mt ditt l\u00f6senord?",
"French": "Franska",
"From": "Fr\u00e5n",
"From date is required": "Fr\u00e5n datum kr\u00e4vs",
"Full Name": "Fullst\u00e4ndigt namn",
"Full Year": "Hel\u00e5r",
"Gain control of your energy spending": "F\u00e5 kontroll \u00f6ver din energif\u00f6rbrukning",
"Gas": "Gas",
"Generate API Key": "Generera API-nyckel",
"Generate Climate Report": "Generera klimatrapport",
"Generate Cost Report": "Generera kostnadsrapport",
"Generate Email": "Generera e-post",
"Generate Energy Report": "Generera energirapport",
"Generate Sport Price Report": "Skapa rapport om sportpriser",
"Generating Excel file": "Generering av Excel-fil",
"German": "Tyska",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "F\u00e5 full insyn i dina energif\u00f6rbrukningar med mindre manuellt arbete",
"Getting Data": "H\u00e4mta data",
"Go to App": "G\u00e5 till appen",
"Green Certificates": "Gr\u00f6na certifikat",
"Green Electricity": "Gr\u00f6n el",
"Grid company": "N\u00e4tbolag",
"Heating": "Uppv\u00e4rmning",
"Historical Data": "Historiska data",
"Historical Data Limits": "Historiska datagr\u00e4nser",
"Hour": "Timme",
"Hour Report - Under development": "Timmarsrapport \u2013 Under utveckling",
"Hourly": "Varje timme",
"Hours": "Timmar",
"House No.": "Hus nr.",
"How many buildings company have": "Hur m\u00e5nga byggnader har f\u00f6retaget",
"How many meters company have": "Hur m\u00e5nga m\u00e4tare har f\u00f6retaget",
"I agree with": "Jag h\u00e5ller med",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Om datan \u00e4r tung kan det h\u00e4nda att den fortfarande laddas.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Om du inte vill ange n\u00e5gon gr\u00e4ns l\u00e4gger du till 999 i det numeriska f\u00e4ltet. Om du inte vill ge n\u00e5gon \u00e5tkomst kan du hantera det i prenumerationsplanens funktioner. F\u00f6r att implementera denna gr\u00e4ns f\u00f6r historiska data m\u00e5ste du dock koppla den till prenumerationsplanen.",
"InActive": "Inaktiv",
"Inkl. Moms": "Inkl. moms",
"Installation Numbers": "Installationsnummer",
"Installation number": "Installationsnummer",
"Installation number is required": "Installationsnummer kr\u00e4vs",
"Internet connection restored": "Internetanslutningen \u00e5terst\u00e4lld",
"Interval": "Intervall",
"Invite User": "Bjud in anv\u00e4ndare",
"Invoice": "Faktura",
"Invoices": "Fakturor",
"It appears that no company is associated with your account.": "Det verkar som om inget f\u00f6retag \u00e4r kopplat till ditt konto.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Det kommer att ladda ner en zip-fil som inneh\u00e5ller PO- och POT-filerna. PO-filen inneh\u00e5ller de befintliga \u00f6vers\u00e4ttningarna och POT-filen inneh\u00e5ller den senaste texten som beh\u00f6ver \u00f6vers\u00e4ttas. Vi kan anv\u00e4nda programvaran Poedit f\u00f6r att importera POT-texten till PO-filen och \u00f6vers\u00e4tta den.",
"Item": "Artikel",
"Items": "Artiklar",
"Jan": "Jan",
"Jan: Checking": "Jan: Kontroll",
"Jan: Get": "Jan: H\u00e4mta",
"Jan: Update": "Jan: Uppdatering",
"January": "Januari",
"Japanese": "Japanska",
"Jul": "Jul",
"Jul: Checking": "Jul: Kontroll",
"Jul: Get": "Jul: H\u00e4mta",
"Jul: Update": "Jul: Uppdatering",
"July": "Juli",
"Jun": "Jun",
"Jun: Checking": "Jun: Kontroll",
"Jun: Get": "Jun: H\u00e4mta",
"Jun: Update": "Jun: Uppdatering",
"June": "Juni",
"Key": "Nyckel",
"Key, Alpha numeric and dash only": "Nyckel, endast alfanumerisk och bindestreck",
"Kg of CO\u2082e": "Kg CO\u2082e",
"Kilogram": "Kilogram",
"LNG": "LNG",
"Language": "Spr\u00e5k",
"Languages": "Spr\u00e5k",
"Last Login": "Senaste inloggning",
"Last Run": "Senaste k\u00f6rningen",
"Last date": "Senaste datum",
"Last seen": "Senast sedd",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Som alla andra webbplatser anv\u00e4nder Fabeke \"cookies\". Dessa cookies anv\u00e4nds f\u00f6r att lagra information, inklusive bes\u00f6karnas preferenser, och de sidor p\u00e5 webbplatsen som bes\u00f6karen har kommit \u00e5t eller bes\u00f6kt. Informationen anv\u00e4nds f\u00f6r att optimera anv\u00e4ndarnas upplevelse genom att anpassa inneh\u00e5llet p\u00e5 v\u00e5ra webbsidor baserat p\u00e5 bes\u00f6karnas webbl\u00e4sartyp och/eller annan information.",
"Link": "L\u00e4nk",
"Link User": "L\u00e4nk anv\u00e4ndare",
"Link company": "L\u00e4nk f\u00f6retag",
"Link user": "L\u00e4nk anv\u00e4ndare",
"List View": "Listvy",
"List as": "Lista som",
"Loading": "Laddar",
"Loading security verification...": "Laddar s\u00e4kerhetsverifiering...",
"Loading...": "Laddar...",
"Location": "Plats",
"Location and above level access": "Plats och tillg\u00e4nglighet \u00f6ver markniv\u00e5",
"Login": "Logga in",
"Login as": "Logga in som",
"Login code": "Inloggningskod",
"Login failed! Please try again": "Inloggning misslyckades! V\u00e4nligen f\u00f6rs\u00f6k igen",
"Login successful. Redirecting.": "Inloggningen lyckades. Omdirigering p\u00e5g\u00e5r.",
"Login with your new password right away.": "Logga in med ditt nya l\u00f6senord direkt.",
"Main Price Type": "Huvudpris Typ",
"Mandarin": "mandarin",
"Mar": "Mars",
"Mar: Checking": "Mar: Kontroll",
"Mar: Get": "Mar: H\u00e4mta",
"Mar: Update": "Mar: Uppdatering",
"March": "Mars",
"Mark As Read": "Markera som l\u00e4st",
"Markup": "M\u00e4rkspr\u00e5k",
"Markup Price": "Markup-pris",
"Markup Share": "Markup-andel",
"Max size supported 20MB": "Maximal storlek som st\u00f6ds 20 MB",
"Maximum 50 symbols": "H\u00f6gst 50 symboler",
"May": "Maj",
"May: Checking": "Maj m\u00e5nad: Kontroll",
"May: Get": "Maj: H\u00e4mta",
"May: Update": "Maj: Uppdatering",
"Message": "Meddelande",
"Meter": "M\u00e4tare",
"Meter No": "M\u00e4tare Nej",
"Meter and above level access": "M\u00e4tare och \u00e5tkomst \u00f6ver niv\u00e5",
"Meter number": "M\u00e4tarnummer",
"Meter reading end date": "Slutdatum f\u00f6r m\u00e4taravl\u00e4sning",
"Meter reading start date": "Startdatum f\u00f6r m\u00e4taravl\u00e4sning",
"Minimum 3 symbols": "Minst 3 symboler",
"Minimum Fee": "L\u00e4gsta avgift",
"Modals": "Modals",
"Module": "Modul",
"Module code, Alpha numeric and dash only": "Modulkod, endast alfanumerisk och bindestreck",
"Module name": "Modulens namn",
"Moms": "Moms",
"Month": "M\u00e5nad",
"Month Columns: Downloading": "M\u00e5nadens kolumner: Nedladdning",
"Month Columns: Processing": "M\u00e5nadens kolumner: Bearbetning",
"Month Data: Downloading": "M\u00e5nadsdata: Nedladdning",
"Month Data: Processing": "M\u00e5nadsdata: Bearbetning",
"Month Report - Under development": "M\u00e5nadsrapport \u2013 Under utveckling",
"Monthly": "M\u00e5nadsvis",
"Monthly Statement": "M\u00e5nadsbesked",
"Months": "M\u00e5nader",
"Must be a valid email": "M\u00e5ste vara en giltig e-postadress",
"My Account": "Mitt Konto",
"My Companies": "Mina f\u00f6reningar",
"My Profile": "Min profil",
"Name": "Namn",
"Name is required.": "Namn \u00e4r en obligatorisk uppgift, v\u00e4nligen fyll i ditt namn.",
"Natural Gas": "Naturgas",
"Net": "Netto",
"Net Tariff": "Netto Tariff",
"Never Login": "Logga aldrig in",
"New": "Ny",
"New Password": "Nytt l\u00f6senord",
"New Password is required": "Nytt l\u00f6senord kr\u00e4vs",
"No": "Nej",
"No Company": "Inget f\u00f6retag",
"No Documents Found": "Inga dokument hittades",
"No Historical Data Limit": "Ingen begr\u00e4nsning av historiska data",
"No Limit": "Ingen gr\u00e4ns",
"No Partner": "Ingen partner",
"No Results Found!": "Inga resultat hittades!",
"No Rows": "Inga rader",
"No data found": "Inga data hittades",
"No document available for preview": "Inget dokument tillg\u00e4ngligt f\u00f6r f\u00f6rhandsgranskning",
"No internet connection. Please check your network.": "Ingen internetanslutning. Kontrollera ditt n\u00e4tverk.",
"No option available": "Inget alternativ tillg\u00e4ngligt",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Ingen anv\u00e4ndning av Fabeke's logotyp eller andra illustrationer kommer att till\u00e5tas f\u00f6r l\u00e4nkning utan ett licensavtal f\u00f6r varum\u00e4rke.",
"Norwegian": "Norska",
"Not Applicable": "Ej till\u00e4mpligt",
"Not Cached": "Inte cachad",
"Not Found": "Hittades inte",
"Notes": "Anteckningar",
"Notification has been deleted": "Notis har raderats",
"Notification marked as read": "Aviseringen har markerats som l\u00e4st",
"Notifications": "Aviseringar",
"Nov": "Nov",
"Nov: Checking": "Nov: Kontroll",
"Nov: Get": "Nov: H\u00e4mta",
"Nov: Update": "Nov: Uppdatering",
"November": "November",
"Oct": "Okt",
"Oct: Checking": "Okt: Kontroll",
"Oct: Get": "Okt: H\u00e4mta",
"Oct: Update": "Okt: Uppdatering",
"October": "Oktober",
"Official address of meter (not including location information)": "Officiell adress till m\u00e4taren (inkluderar inte platsinformation)",
"Often the number on company's bill": "Ofta numret p\u00e5 f\u00f6retagets faktura",
"Oil": "Olja",
"One Month Energy Consumption (kWh)": "En m\u00e5nads energif\u00f6rbrukning (kWh)",
"One Month Tariff (kWh)": "En m\u00e5nads tariff (kWh)",
"Only PDF files are allowed.": "Endast PDF-filer \u00e4r till\u00e5tna.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Endast PDF-filer \u00e4r till\u00e5tna. L\u00e4mna tomt f\u00f6r att beh\u00e5lla den befintliga filen.",
"Only for system level users": "Endast f\u00f6r anv\u00e4ndare p\u00e5 systemniv\u00e5",
"Only lowercase alphanumeric characters and dashes are allowed": "Endast sm\u00e5 bokst\u00e4ver, alfanumeriska tecken och bindestreck \u00e4r till\u00e5tna",
"Order No": "Ordernummer",
"Order Numbers": "Order nummer",
"Others": "Andra",
"Overall statement": "\u00d6vergripande uttalande",
"Parameter showing Electricity consumption": "Parameter som visar Elf\u00f6rbrukning",
"Parent Company": "Moderbolaget",
"Parent company and above level access": "Moderbolag och \u00e5tkomst till h\u00f6gre niv\u00e5er",
"Partner": "Partner",
"Partner Users for ": "Partneranv\u00e4ndare f\u00f6r ",
"Partner and above level access": "Partner och h\u00f6gre niv\u00e5er",
"Partners": "Partners",
"Partnerships Team": "Partnerskapsteam",
"Password": "L\u00f6senord",
"Password Changed": "L\u00f6senord \u00e4ndrat",
"Passwords didn't match": "L\u00f6senorden st\u00e4mde inte \u00f6verens",
"Period/Sum": "Period/Summa",
"Permissions": "Beh\u00f6righeter",
"Permissions for ": "Beh\u00f6righeter f\u00f6r ",
"Personal": "Personlig",
"Personal Information": "Personlig Information",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Observera ocks\u00e5 att f\u00f6r att ber\u00e4kna utsl\u00e4ppsgraden fr\u00e5n CO2 anv\u00e4nds 125%-metoden, vilket inneb\u00e4r att samproducerad v\u00e4rme produceras med en given effektivitet med 125%.",
"Please authorize us on": "V\u00e4nligen kontakta oss p\u00e5",
"Please enter a valid email and password!": "Ange en giltig e-postadress och ett giltigt l\u00f6senord!",
"Please enter a valid email!": "Ange en giltig e-postadress!",
"Please enter a valid password!": "Ange ett giltigt l\u00f6senord!",
"Please select a file to upload": "V\u00e4lj en fil att ladda upp",
"Please wait": "V\u00e4nligen v\u00e4nta",
"Please wait while security verification loads...": "V\u00e4nta medan s\u00e4kerhetsverifieringen laddas...",
"Price": "Pris",
"Price (cent/kWh)": "Pris (cent/kWh)",
"Price (pence/kWh)": "Pris (pence/kWh)",
"Price (\u00d8re/kWh)": "Pris (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Pris (\u00f6re/kWh)",
"Price Price": "Pris Pris",
"Price Share": "Pris Aktie",
"Price Type": "Pristyp",
"Price elements": "Priselement",
"Price in (\u00d8re/kWh)": "Pris i (\u00d8re/kWh)",
"Price kWh": "Pris kWh",
"Price type": "Typ av pris",
"Price type is required": "Pristyp kr\u00e4vs",
"Prices": "Priser",
"Prices, tariffs, taxes and cost": "Priser, tariffer, skatter och kostnader",
"Privacy Policy": "Integritetspolicy",
"Privacy Policy for Fabeke": "Integritetspolicy f\u00f6r Fabeke",
"Procurement": "Upphandling",
"Profile": "Profil",
"Profile Price": "Profil Pris",
"Profile Share": "Profil Aktie",
"Profile Type": "Profil typ",
"Profile kWh": "Profil kWh",
"Q1": "Q1",
"Q2": "Q2",
"Q3": "Q3",
"Q4": "Q4",
"Quantity (kWh)": "M\u00e4ngd (kWh)",
"Questions?": "Fr\u00e5gor?",
"Rabat Net Tariff": "Rabat Net Tariff",
"Read All Notifications": "L\u00e4s alla meddelanden",
"Read Notification": "L\u00e4s anm\u00e4lan",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "\u00c4r du redo att f\u00f6rb\u00e4ttra ditt erbjudande? Prata med n\u00e5gon fr\u00e5n v\u00e5rt partnerskapsteam idag och b\u00f6rja anv\u00e4nda ",
"Real-time, precise, and automated.": "Realtid, exakt och automatiserad.",
"Recover Password": "\u00c5terst\u00e4ll L\u00f6senord",
"Registered successful. Redirecting.": "Registrerad framg\u00e5ngsrik. Omdirigering.",
"Remove file": "Ta bort fil",
"Report": "Rapportera",
"Reports": "Rapporter",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Beg\u00e4ra att ett f\u00f6retag som samlar in en konsuments personuppgifter l\u00e4mnar ut de kategorier och specifika personuppgifter som f\u00f6retaget har samlat in om konsumenter.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Beg\u00e4r att ett f\u00f6retag som s\u00e4ljer en konsuments personuppgifter inte s\u00e4ljer konsumentens personuppgifter.",
"Require all devices to sign in again with the new password.": "Kr\u00e4v att alla enheter loggar in igen med det nya l\u00f6senordet.",
"Reset Completed": "\u00c5terst\u00e4llning slutf\u00f6rd",
"Reset Password": "\u00c5terst\u00e4ll l\u00f6senord",
"Reset Your Password": "\u00c5terst\u00e4ll ditt l\u00f6senord",
"Role": "Roll",
"Role Specific Information": "Rollspecifik information",
"Role key, Alpha numeric and dash only": "Rollnyckel, endast alfanumeriska och bindestreck",
"Roles": "Roller",
"Save": "Spara",
"Save All For": "Spara allt f\u00f6r",
"Save Changes": "Spara \u00e4ndringar",
"Save Profile": "Spara Profil",
"Saving. Please wait.": "Spara. V\u00e4nligen v\u00e4nta.",
"Scraper List": "Skraplista",
"Scraper Log": "Skraplog",
"Scraper Name": "Skrapans namn",
"Search": "S\u00f6k",
"See All Notifications": "Se alla meddelanden",
"Select": "V\u00e4lj",
"Select Company": "V\u00e4lj f\u00f6rening",
"Select date range": "V\u00e4lj datumintervall",
"Select your locality": "V\u00e4lj din ort",
"Send Link to Email": "Skicka l\u00e4nk till e-post",
"Send the user a notification via email.": "Skicka ett meddelande till anv\u00e4ndaren via e-post.",
"Sep": "Sep",
"Sep: Checking": "Sep: Kontroll",
"Sep: Get": "Sep: H\u00e4mta",
"Sep: Update": "Sep: Uppdatering",
"September": "September",
"Settings": "Inst\u00e4llningar",
"Setup a unique password to protect your account.": "Ange ett unikt l\u00f6senord f\u00f6r att skydda ditt konto.",
"Share": "Dela",
"Share (%)": "Andel (%)",
"Show up to": "Visa upp till",
"Sign In": "Logga in",
"Sign Out": "Logga ut",
"Sign Up": "Registrera dig",
"Sign in": "Logga in",
"Sign up": "Registrera dig",
"Simple": "Enkel",
"Spanish": "Spanska",
"Spot (60%)": "Spot (60%)",
"Spot Premium Price": "Spot Premium Pris",
"Spot Premium Share": "Spot Premium Andel",
"Spot Price": "Spotpris",
"Spot Prices": "Spotpriser",
"Spot premium": "Spotpremie",
"Spotpris": "Spotpris",
"Start": "Start",
"Start Date": "Startdatum",
"Statement": "Redog\u00f6relse",
"Statement Export": "Utl\u00e5tande Export",
"Status": "Status",
"Still Loading": "Laddar fortfarande",
"Street": "Gata",
"Submit": "Skicka",
"Subscription": "Prenumeration",
"Subscription Expire At": "Prenumerationen l\u00f6per ut den",
"Subscription Expired!": "Prenumerationen har g\u00e5tt ut!",
"Subscription Expiring Soon!": "Prenumerationen l\u00f6per snart ut!",
"Subscription Plan": "Medlems plan",
"Subscription Plan Name": "Namn p\u00e5 prenumerationsplan",
"Subscription Plan added Successfully": "Prenumerationsplan tillagd framg\u00e5ngsrikt",
"Subscription Plans": "Prenumerationspaket",
"Subscription key, Alpha numeric and dash only": "Prenumerationsnyckel, endast alfanumerisk och bindestreck",
"Subscription updated Successfully": "Prenumeration uppdaterad framg\u00e5ngsrikt",
"Sum": "Summa",
"Sum/Average": "Summa/Medelv\u00e4rde",
"Support": "Support",
"Swedish": "Svenska",
"Switch as": "V\u00e4xla som",
"System": "System",
"System Partners": "Systempartners",
"System Price": "Systemets pris",
"System Roles": "Systemroller",
"System Share": "Systemandel",
"System Tariff": "Systemtariff",
"System Type": "Typ av system",
"System Users": "Anv\u00e4ndare av systemet",
"System kWh": "System kWh",
"TSO - System Subscription": "TSO - Systemabonnemang",
"Take control of your energy expenses with": "Ta kontroll \u00f6ver dina energikostnader med",
"Tariff": "Prislista",
"Tax": "Moms",
"Taxes (\u00d8re/kWh)": "Skatter (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Skatter i (\u00d8re/kWh)",
"Tenants": "Kunder",
"Terms & Conditions": "Anv\u00e4ndarvillkor",
"Test Climate Report": "Test klimatrapport",
"Test Energy Report": "Test av energirapport",
"Test Sport Price Report": "Test Sport Prisrapport",
"Test report": "Testrapport",
"Thank you for registering with us. We're excited to have you on board!": "Tack f\u00f6r att du har registrerat dig hos oss. Vi \u00e4r glada \u00f6ver att ha dig ombord!",
"Thanks for signing up!": "Tack f\u00f6r att du anm\u00e4lt dig!",
"That is great that you know that.": "Det \u00e4r bra att du vet det.",
"The POC has been updated.": "POC har uppdaterats.",
"The cache has been cleared": "Cachen har rensats",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Ber\u00e4kningarna av CO2-utsl\u00e4ppen baseras p\u00e5 utsl\u00e4pp fr\u00e5n varje kraftverk \u00f6ver 10 MW och d\u00e4r alla kraftverk under 10 MW betraktas som ett kraftverk. Vidare baseras ber\u00e4kningarna p\u00e5 produktion per timme, f\u00f6rbrukning per timme och utbyte per timme.",
"The company already linked.": "F\u00f6retaget \u00e4r redan l\u00e4nkat.",
"The company has been linked.": "Bolaget har l\u00e4nkats.",
"The company has been unlinked.": "Bolaget har avknoppats.",
"The data limit has been updated": "Datagr\u00e4nsen har uppdaterats",
"The deal has updated": "Aff\u00e4ren har uppdaterats",
"The document has been uploaded.": "Dokumentet har laddats upp.",
"The email has been sent": "E-postmeddelandet har skickats",
"The file has been exported.": "Filen har exporterats.",
"The historical data limit has been added.": "Den historiska datagr\u00e4nsen har lagts till.",
"The mail already exists in the system!": "Mailet finns redan i systemet!",
"The metering point id from datahub": "M\u00e4tpunktens id fr\u00e5n datahub",
"The module has been updated": "Modulen har uppdaterats",
"The new POC has been added.": "Den nya POC:en har lagts till.",
"The new deal has added": "Det nya avtalet har lagt till",
"The new feature has been added": "Den nya funktionen har lagts till",
"The new module has been added": "Den nya modulen har lagts till",
"The new partner has been added.": "Den nya partnern har lagts till.",
"The new role has been added.": "Den nya rollen har lagts till.",
"The new user has been added.": "Den nya anv\u00e4ndaren har lagts till.",
"The partner has been updated.": "Partnern har uppdaterats.",
"The password has been reset.": "L\u00f6senordet har \u00e5terst\u00e4llts.",
"The password has been updated.": "L\u00f6senordet har uppdaterats.",
"The registration is by invitation only.": "Registreringen sker endast p\u00e5 inbjudan.",
"The role has been updated": "Rollen har uppdaterats",
"The session has been expired.": "Sessionen har l\u00f6pt ut.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Systemet skapar nu rapporten, och du kan ladda ner den inom kort genom att klicka p\u00e5 Download.",
"The user already linked.": "Anv\u00e4ndaren har redan l\u00e4nkat.",
"The user has been linked.": "Anv\u00e4ndaren har l\u00e4nkats.",
"The user has been unlinked.": "Anv\u00e4ndaren har blivit avl\u00e4nkad.",
"The user has been updated": "Anv\u00e4ndaren har uppdaterats",
"The year cache has been updated": "\u00c5rscachen har uppdaterats",
"There are no documents matching your criteria.": "Det finns inga dokument som matchar dina kriterier.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Dessa villkor beskriver regler och best\u00e4mmelser f\u00f6r anv\u00e4ndningen av Fabeke's webbplats, som finns p\u00e5 https://www.fabeke.com",
"Third Party Privacy Policies": "Tredje parts integritetspolicy",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Tredjeparts annonsservrar eller annonsn\u00e4tverk anv\u00e4nder tekniker som cookies, JavaScript eller webb-beacons som anv\u00e4nds i deras respektive annonser och l\u00e4nkar som visas p\u00e5 Fabeke, som skickas direkt till anv\u00e4ndarnas webbl\u00e4sare. De tar automatiskt emot din IP-adress n\u00e4r detta sker. Dessa tekniker anv\u00e4nds f\u00f6r att m\u00e4ta effektiviteten i deras reklamkampanjer och/eller f\u00f6r att anpassa det reklaminneh\u00e5ll som du ser p\u00e5 webbplatser som du bes\u00f6ker.",
"This area is forbidden. Turn back now!": "Detta omr\u00e5de \u00e4r f\u00f6rbjudet. V\u00e4nd om nu!",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Det h\u00e4r \u00e4r en f\u00f6rvarning till alla! Vi har tillf\u00e4lligt pausat nya registreringar. Men oroa er inte, vi kommer att \u00f6ppna dem igen inom kort. H\u00e5ll \u00f6gonen \u00f6ppna!",
"Thumbnail View": "Miniatyrbildsvy",
"Time Zone": "Tidszon",
"Timestamp of last encountered when requesting data from datahub": "Tidsst\u00e4mpel f\u00f6r det senaste tillf\u00e4llet d\u00e5 data beg\u00e4rdes fr\u00e5n datahubben",
"Timezone": "Tidszon",
"To": "Till",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "F\u00f6r att slutf\u00f6ra din registrering och aktivera ditt konto, v\u00e4nligen bekr\u00e4fta din e-postadress genom att klicka p\u00e5 nedan:",
"To date is required": "Hittills kr\u00e4vs",
"To ensure the data is tailored to your local time, we require your": "F\u00f6r att s\u00e4kerst\u00e4lla att uppgifterna \u00e4r anpassade efter din lokala tid beh\u00f6ver vi din",
"Total Electricity Charge": "Total elavgift",
"Translation": "\u00d6vers\u00e4ttning",
"Transmission Grid Tariff": "Tariff f\u00f6r \u00f6verf\u00f6ringsn\u00e4t",
"Type": "Typ",
"Type of meter. E17 = consumption, E18 = production": "Typ av m\u00e4tare. E17 = f\u00f6rbrukning, E18 = produktion",
"URL": "URL",
"Under construction": "Under uppbyggnad",
"Unit": "Enhet",
"Unknown Error Occurred !": "Ok\u00e4nt fel har intr\u00e4ffat!",
"Unknown error1 Occurred !": "Ok\u00e4nd fel1 intr\u00e4ffade!",
"Unlink": "Ta bort l\u00e4nk",
"Update": "Uppdatera",
"Update Roles": "Uppdatera roller",
"Update failed": "Uppdatering misslyckades",
"Update your Image and other data here.": "Uppdatera din bild och andra uppgifter h\u00e4r.",
"Updated At": "Uppdaterad",
"Updating...": "Uppdaterar...",
"Upload": "Ladda upp",
"Upload Data": "Ladda upp data",
"Upload Document Files": "Ladda upp dokumentfiler",
"Upload New Document": "Ladda upp nytt dokument",
"Upload New Document File (Optional)": "Ladda upp ny dokumentfil (valfritt)",
"Upload PO file": "Ladda upp PO-fil",
"Upload Po file": "Ladda upp Po-fil",
"Uploaded": "Uppladdat",
"Uploading": "Laddar upp",
"Uploading...": "Laddar upp...",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Anv\u00e4nd den h\u00e4r sidan f\u00f6r att uppdatera programmets version. N\u00e4r du \u00e4ndrar versionen kommer applikationen p\u00e5 klientsidan automatiskt att h\u00e4mta och k\u00f6ra den senaste koden fr\u00e5n servern.",
"Used:": "Anv\u00e4nd:",
"User Data": "Anv\u00e4ndardata",
"User ID is missing": "Anv\u00e4ndar-ID saknas",
"Users": "Anv\u00e4ndare",
"Users for the business: ": "Anv\u00e4ndare f\u00f6r f\u00f6retaget: ",
"Users for the corporate group: ": "Anv\u00e4ndare f\u00f6r koncernen: ",
"V_per_m2": "V_per_m2",
"Validating period": "Valideringsperiod",
"Validating. Please wait.": "Validerar. V\u00e4nta ett \u00f6gonblick.",
"Validity end date": "Giltighetsslutdatum",
"Validity start date": "Giltighetens startdatum",
"Variable/Spot/Nordpool price": "Variabelt/Spot/Nordpool-pris",
"Verification Successful": "Verifiering framg\u00e5ngsrik",
"Verify Password": "Bekfr\u00e4fta l\u00f6senord",
"Version": "Version",
"Version Management": "Hantering av versioner",
"View": "Visa",
"View Mode": "Visningsl\u00e4ge",
"View meter details": "Visa m\u00e4taruppgifter",
"Water": "Vatten",
"We are unable to find your email address": "Vi kan inte hitta din e-postadress",
"We couldn't find what you searched for": "Vi kunde inte hitta det du s\u00f6kte efter",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Vi anv\u00e4nder oss av cookies. Genom att bes\u00f6ka Fabeke samtycker du till att anv\u00e4nda cookies i enlighet med Fabekes integritetspolicy.",
"We have updated the reports for last month, and you can download the reports by clicking below": "Vi har uppdaterat rapporterna f\u00f6r f\u00f6rra m\u00e5naden, och du kan ladda ner rapporterna genom att klicka nedan",
"Website": "Webbplats",
"Welcome to": "V\u00e4lkommen till",
"Welcome to ": "V\u00e4lkommen till ",
"What do you know?": "Vad vet du om det?",
"Wrong password!": "Fel l\u00f6senord!",
"Year": "\u00c5r",
"Year Data: Downloading": "\u00c5r Data: Nedladdning",
"Year Data: Processing": "\u00c5r Data: Bearbetning",
"Year Report - Under development": "\u00c5rsrapport \u2013 Under utveckling",
"Year: Get": "\u00c5r: Get",
"Year: Update": "\u00c5r: Uppdatering",
"Yearly": "\u00c5rlig",
"Years": "\u00c5r",
"Yes": "Ja",
"Yes I know that.": "Ja, jag vet det.",
"You are not authorized to perform this action": "Du \u00e4r inte beh\u00f6rig att utf\u00f6ra denna \u00e5tg\u00e4rd",
"You can change your password here": "Du kan \u00e4ndra ditt l\u00f6senord h\u00e4r",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Du kan v\u00e4lja att inaktivera cookies genom dina individuella webbl\u00e4saralternativ. Mer detaljerad information om hantering av cookies med specifika webbl\u00e4sare finns p\u00e5 webbl\u00e4sarens respektive webbplats.",
"You can continue to use our services now. ": "Du kan forts\u00e4tta att anv\u00e4nda v\u00e5ra tj\u00e4nster nu. ",
"You can now use your new password to sign in to your account.": "Du kan nu anv\u00e4nda ditt nya l\u00f6senord f\u00f6r att logga in p\u00e5 ditt konto.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Du kan bara ladda upp PO-filen. N\u00e4r du har laddat upp den filen tar det n\u00e4stan 10 minuter att \u00e5terspegla \u00e4ndringarna p\u00e5 webbplatsen.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du har blivit inbjuden av {{partner_name}} att g\u00e5 med som {{role_name}}. F\u00f6r att forts\u00e4tta klickar du p\u00e5 Logga in f\u00f6r att komma \u00e5t systemet.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du har bjudits in av {{partner_name}} att g\u00e5 med som {{role_name}}. F\u00f6r att forts\u00e4tta m\u00e5ste du skapa ett l\u00f6senord f\u00f6r att f\u00e5 tillg\u00e5ng till systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du har blivit inbjuden av {{tenant_name}} att g\u00e5 med som {{role_name}}. F\u00f6r att forts\u00e4tta klickar du p\u00e5 Logga in f\u00f6r att komma \u00e5t systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du har bjudits in av {{tenant_name}} att g\u00e5 med som {{role_name}}. F\u00f6r att forts\u00e4tta m\u00e5ste du skapa ett l\u00f6senord f\u00f6r att f\u00e5 tillg\u00e5ng till systemet.",
"Your Picture": "Din bild",
"Your account doesn\u2019t exist, please Sign Up": "Ditt konto finns inte, v\u00e4nligen registrera dig",
"Your login session has been expired. Please log in again": "Din inloggningssession har l\u00f6pt ut. V\u00e4nligen logga in igen",
"Your password has been changed": "Ditt l\u00f6senord har \u00e4ndrats",
"Your password has been successfully reset.": "Ditt l\u00f6senord har \u00e5terst\u00e4llts.",
"Your private file": "Din privata fil",
"Your profile has been updated": "Din profil har uppdaterats",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Din prenumeration har l\u00f6pt ut. F\u00f6rnya nu f\u00f6r att \u00e5terf\u00e5 tillg\u00e5ng till ditt konto och alla premiumfunktioner.",
"Your subscription will expire in": "Din prenumeration l\u00f6per ut om",
"Zip Code": "Postnummer",
"aggregated": "aggregerad",
"all": "alla",
"and": "och",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "och Fabeke Tech tar inte ansvar f\u00f6r eventuella fel i inl\u00e4mnade uppgifter och listor",
"browse": "bl\u00e4ddra",
"cache has been updated": "cachen har uppdaterats",
"clicking the link we just emailed you at ": "klicka p\u00e5 l\u00e4nken som vi just mailade dig p\u00e5 ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "samlar in dina energidata, priser och koldioxidutsl\u00e4pp fr\u00e5n alla relevanta datak\u00e4llor och presenterar din energif\u00f6rbrukning, priser, skatter, kostnader och koldioxidutsl\u00e4pp i v\u00e5r plattform f\u00f6r energiutgifter.",
"comprehensive data and insights": "omfattande data och insikter",
"contact us": "kontakta oss",
"converts data into your language and local time zone": "konverterar data till ditt spr\u00e5k och din lokala tidszon",
"country, timezone and corporate group": "land, tidszon och f\u00f6retagsgrupp",
"does not take responsibility for any errors in submitted data and lists": "tar inte ansvar f\u00f6r eventuella fel i inl\u00e4mnade uppgifter och listor",
"export": "export",
"export to CSV": "exportera till CSV",
"export to Excel": "exportera till Excel",
"export to PDF": "exportera till PDF",
"files": "filer",
"for any queries.": "f\u00f6r eventuella fr\u00e5gor.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "ger dig",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "din energianv\u00e4ndning, dina kostnader och ditt koldioxidavtryck.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "m\u00e4ta koldioxidf\u00f6rbrukningen. potentialskillnaden \u00f6ver en yta anv\u00e4nder vi enheten koldioxid per kvadratmeter (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "n\u00e4r vi m\u00e4ter den elektriska potentialskillnaden \u00f6ver en yta anv\u00e4nder vi enheten volt per kvadratmeter (V/m2)",
"or": "eller",
"page": "sida",
"q": "q",
"real-time, accurate insights": "korrekta insikter i realtid",
"ubscription Expire A": "Prenumerationens giltighetstid l\u00f6per ut A",
"v": "v"
},
"plural": "(n != 1)"
}